import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WaterReminderComponent } from './water-reminder/water-reminder.component';
import { ReminderComponent } from './reminder.component';
import { SleepReminderComponent } from './sleep-reminder/sleep-reminder.component';
import { MedicineReminderComponent } from './medicine-reminder/medicine-reminder.component';
import { CustomReminderComponent } from './custom-reminder/custom-reminder.component';

const routes: Routes = [
  { path: '', component: ReminderComponent },
  { path: 'reminder', component: ReminderComponent },
  { path: 'water-reminder', component: WaterReminderComponent },
  { path: 'sleep-reminder', component: SleepReminderComponent },
  { path: 'medicine-reminder', component: MedicineReminderComponent },
  { path: 'custom-reminder', component: CustomReminderComponent }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReminderRoutingModule { }